var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaA310104(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "40 40 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #9989c1;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.8px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26415",
    className: "st0",
    d: "M82.2,111.2l6.4,6.4c8,8,21.1,8,29.1,0h0c8-8,8-21.1,0-29.1l-12.8-12.8-29.1,29.1-12.8-12.8c-8-8-8-21.1,0-29.1h0c8-8,21.1-8,29.1,0h0s6.9,6.9,6.9,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26416",
    className: "st0",
    d: "M69.6,69.7h0c-4.5,4.5-4.5,11.8,0,16.3h0l4.7,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26417",
    className: "st0",
    d: "M111.1,110.8h0c4.5-4.5,4.5-11.8,0-16.3l-4.7-4.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaA310104);
export default __webpack_public_path__ + "static/media/hla-a31-01-04.3ed5ee0a3749294216b77b4e59e82e3a.svg";
export { ForwardRef as ReactComponent };